export default "__VITE_ASSET__B_ayaPYX__"